import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getMoment, deleteMoment } from '../api/moments';
import { useAuth } from '../contexts/AuthContext';

function MomentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUserId } = useAuth();
  const [moment, setMoment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    getMoment(id, token)
      .then(data => setMoment(data.moment))
      .catch(() => setError('Moment introuvable'))
      .finally(() => setLoading(false));
  }, [id]);

  const handleDelete = async () => {
    if (!window.confirm('Supprimer ce moment ?')) return;
    const token = localStorage.getItem('auth_token');
    await deleteMoment(id, token);
    navigate('/moments');
  };

  if (loading) return <div className="loading">Chargement...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!moment) return <div className="error">Moment introuvable</div>;

  return (
    <div className="moment-detail">
      <button onClick={() => navigate(-1)} className="back-link">← Back</button>
      <h1>Mon Moment</h1>
      <p className="moment-event-name">{moment.event_name}</p>
      <p className="moment-description">{moment.description}</p>
      {moment.user_id === currentUserId && (
        <button onClick={handleDelete} className="btn-delete-discreet">Supprimer ce moment</button>
      )}
    </div>
  );
}

export default MomentDetail;
